export default __webpack_public_path__ + "d3a353793424c8996dbfcbb5e448a2e0.png";